import { useEffect, useRef } from 'react';
import { useGetAllProducts1 } from '@/shared/api/client/customer-product-controller';
import { useGroup } from '@/modules/nub-user/modules/user-group/hooks/use-group';
import { useMemberTemplateCategories } from './useMemberTemplateCategories';

interface UseCustomerCategoryDataLoaderProps {
    customerType: 'INDIVIDUAL' | 'GROUP' | 'BUSINESS';
}

export const useCustomerCategoryDataLoader = ({
    customerType
}: UseCustomerCategoryDataLoaderProps) => {
    const hasLoadedRef = useRef({
        products: false,
        lastCustomerType: ''
    });

    // Track loading states with refs to avoid circular dependencies
    const loadingStateRef = useRef({
        products: false
    });

    // Use orval-generated hook instead of custom useProducts to fix infinite loop
    const {
        data: allProductsResponse,
        isLoading: isLoadingProducts
    } = useGetAllProducts1();

    const {
        groups: userGroups,
        isLoading: isLoadingGroups
    } = useGroup();

    const {
        memberTemplateCategories,
        isLoading: isLoadingMainEntities
    } = useMemberTemplateCategories();

    // Update loading state refs when loading states change
    useEffect(() => {
        loadingStateRef.current.products = isLoadingProducts;
    }, [isLoadingProducts]);

    const allProducts = allProductsResponse;


    // Using orval-generated useGetAllProducts1 hook (no manual fetching needed)
    useEffect(() => {
        hasLoadedRef.current.lastCustomerType = customerType;
    }, [customerType]);

    return {
        // Data
        allProducts,
        userGroups,
        entityFields: null,
        memberTemplateCategories,
        
        // Loading states
        isLoadingProducts,
        isLoadingGroups,
        isLoadingFields: false,
        isLoadingMainEntities
    };
};
